import {
  ChronologicalData,
  GroupedData,
} from '../utils/chronological-data.interface';
import { DateFormatter } from '../date-formatter.class';
import { GroupedChronologicalData } from '../utils/grouped-chronological-data.class';
import { GroupBy } from '../utils/group-by.enum';

/* An abstract class that is used to create a new class that is used to group data. */
export abstract class GroupByStrategyBase<T> {
  abstract group(
    data: ChronologicalData<T>[],
    groupBy: GroupBy,
    locale?: string
  ): GroupedChronologicalData<T>;
}

/* It groups data by day */
export class GroupByDayStrategy<T> extends GroupByStrategyBase<T> {
  /**
   * It takes an array of chronological data, groups it by day, and returns a
   * grouped chronological data object
   * @param {ChronologicalData<T>[]} data - ChronologicalData<T>[]
   * @param {GroupBy} groupBy - This is the type of grouping you want to do. It can
   * be one of the following:
   * @param {string} [locale] - The locale to use for formatting the date.
   * @returns A GroupedChronologicalData<T> object
   */
  group(
    data: ChronologicalData<T>[],
    groupBy: GroupBy,
    locale?: string
  ): GroupedChronologicalData<T> {
    const group = new GroupedChronologicalData<T>(groupBy);
    const dataGroup = data.map((_data) => {
      const label = new DateFormatter(locale).getDayString(_data.date);

      return {
        dates: [_data.date],
        data: [_data.data],
        label,
      } as GroupedData<T>;
    });

    group.data = dataGroup;

    return group;
  }
}
